import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  loading: false,
  error: null,
}

const userSettingsUpdateSlice = createSlice({
  name: "userSettingsUpdate",
  initialState,
  reducers: {
    update(state) {
      state.loading = true
      state.error = null
    },
    updateCompleted(state) {
      state.loading = false
    },
    updateRejected(state, action) {
      state.loading = false
      state.error = action.payload
    },
    cleanState() {
      return initialState
    },
  },
})

export const userSettingsUpdate = userSettingsUpdateSlice.actions

export default userSettingsUpdateSlice.reducer
